import { compose } from 'redux';
import { connect } from 'react-redux';
import React, { useEffect, useState } from 'react';
import { actionProps, selectState } from '../../utils/reduxActions';
import {
  CardContent,
  Button,
  Image,
  Card,
  Header,
  Input,
  CardGroup,
  Menu,
  CardHeader,
  CardDescription,
} from 'semantic-ui-react';
import paths from '../../config/paths';
import '../styles/home.css';
import { trackingActions } from './reducer';

//Function Icons
import FunctionIcon1 from '../../assets/functions/Icon1.svg';
import FunctionIcon2 from '../../assets/functions/Icon2.svg';
import FunctionIcon3 from '../../assets/functions/Icon3.svg';
//Brands Image
import MiniLogo from '../../assets/miniLogo.svg';
import Branch from '../Home/components/branch';
import Footer from '../Home/components/footer';
import Carousel from '../Home/components/carousel';
import Form from '../Home/components/form';
import Benefits from '../Home/components/benefits';
import { Alert, AlertTitle } from '@mui/material';
import {
  CheckCircleIcon,
  TruckIcon,
  XCircleIcon,
} from '@heroicons/react/outline';
import WarningIcon from '@mui/icons-material/Warning';
import HourglassTopOutlinedIcon from '@mui/icons-material/HourglassTopOutlined';
import { getPackageStatus } from '../../utils/guideStatus';

interface PickupData {
  id: string;
  serviceName: string;
  serviceType: string;
  createdAt: string;
  pickupDate: string;
  pickupFolio: string;
}

interface PickupProps {
  actions?: any;
  status?: any;
  trackingStatus?: any;
  history?: any;
  profile?: any;
}

interface PackageStatus {
  status:
    | 'en-camino'
    | 'entregado'
    | 'procesando'
    | 'no-encontrado'
    | 'hay-un-problema';
  message: string;
  updatedStatusAt: string;
}

const Tracking: React.FC<PickupProps> = (props): JSX.Element => {
  const { history, actions, status, trackingStatus } = props;
  const queryParams = new URLSearchParams(window.location.search);
  const [activeItem, setActiveItem] = useState('Sucursales');
  const [widthScreen, setwidthScreen] = useState<number>(window.innerWidth);
  const [trackingNumber, setTrackingNumber] = useState('');
  const [packageStatus, setPackageStatus] = useState<PackageStatus | null>(
    null,
  );
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    window.addEventListener('resize', function () {
      setwidthScreen(window.innerWidth);
    });
  }, [widthScreen]);

  useEffect(() => {
    const trackingNumberFromQuery = queryParams.get('trackingNumber');
    if (trackingNumberFromQuery && trackingNumberFromQuery?.trim().length > 0) {
      setIsLoading(true);
      setTrackingNumber(trackingNumberFromQuery);
      actions.getTrackingNumber(trackingNumberFromQuery);
    } else setIsLoading(false);
  }, []);

  useEffect(() => {
    if (status?.internalStatus) {
      setPackageStatus(null);
      const statusMatch = getPackageStatus(status.internalStatus);
      const statusData = {
        message: status.trackStatus,
        updatedStatusAt: status.updatedStatusAt,
        status: statusMatch.label as PackageStatus['status'],
      };
      setPackageStatus(statusData);
      setIsLoading(false);
    }
  }, [status]);

  useEffect(() => {
    setIsLoading(trackingStatus.loading);
  }, [trackingStatus.loading]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);
    setPackageStatus(null);

    try {
      actions.getTrackingNumber(trackingNumber);
    } catch (err) {
      setError(
        'An error occurred while fetching the package status. Please try again.',
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <CardContent id='container'>
      {/* Section 1 */}
      <CardContent
        id='segmentHome'
        className='self-center bg-primary-inabit-green pb-10'
      >
        {widthScreen > 1000 && (
          <div className='flex flex-row justify-between w-full'>
            <Image
              id='miniLogo'
              src={MiniLogo}
              className='items-start'
            />
            <Menu
              id='menuRightColumn'
              secondary
            >
              <Menu.Menu
                position='right'
                id='menuDiv'
              >
                <Menu.Item
                  href='#section2'
                  id={
                    activeItem === 'Promociones'
                      ? 'MenuItemActive'
                      : 'MenuItemTracking'
                  }
                  name='Promociones'
                  color='grey'
                  onClick={() => setActiveItem('Promociones')}
                />
                <Menu.Item
                  id={
                    activeItem === 'ComoFunciona'
                      ? 'MenuItemActive'
                      : 'MenuItemTracking'
                  }
                  name='¿Cómo funciona?'
                  color='grey'
                  onClick={() => {
                    setActiveItem('ComoFunciona');
                    window.location.href = paths.HOW_IT_WORKS;
                  }}
                >
                  ¿Cómo funciona?
                </Menu.Item>
                <Menu.Item
                  href='#section5'
                  id={
                    activeItem === 'Contacto'
                      ? 'MenuItemActive'
                      : 'MenuItemTracking'
                  }
                  name='Contactos'
                  color='grey'
                  onClick={() => setActiveItem('Contacto')}
                />
                <Menu.Item
                  href='#section6'
                  id={
                    activeItem === 'Sucursales'
                      ? 'MenuItemActive'
                      : 'MenuItemTracking'
                  }
                  name='Sucursales'
                  color='grey'
                  onClick={() => setActiveItem('Sucursales')}
                />
                <Menu.Item
                  id={
                    activeItem === 'Iniciar Sesión'
                      ? 'MenuItemActive'
                      : 'MenuItemTracking'
                  }
                  color='grey'
                  onClick={() => {
                    setActiveItem('Iniciar Sesión');
                    window.location.href = '/login';
                  }}
                >
                  Iniciar Sesión
                </Menu.Item>
              </Menu.Menu>
            </Menu>
          </div>
        )}
        {widthScreen <= 1000 && (
          <div className='grid grid-cols-2 space-x-1 items-center'>
            <div className='grid'>
              <Image src={MiniLogo} />
            </div>
            <div className='grid space-x-4 justify-items-end grid-flow-col auto-cols-max justify-end'>
              <div className='grid align-middle'>
                <button
                  className='bg-primary-inabit-red rounded-lg p-2 text-white'
                  onClick={() => (window.location.href = '#section6')}
                >
                  Sucursales
                </button>
              </div>
              <div className='grid align-middle'>
                <button
                  onClick={() => history.push(paths.LOGIN)}
                  className='bg-primary-inabit-red rounded-lg p-2 text-white'
                >
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    className='h-6 w-6'
                    fill='none'
                    viewBox='0 0 24 24'
                    stroke='currentColor'
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap='round'
                      strokeLinejoin='round'
                      d='M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1'
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        )}
        <div className='flex flex-row justify-center pt-10'>
          <Card className='max-w-md mx-auto self-center justify-center items-center px-4'>
            <CardHeader
              textAlign='center'
              className='pt-5 text-2xl'
            >
              Rastrea tu guía
            </CardHeader>
            <CardDescription className='text-xl py-2'>
              Ingresa tu número de guía
            </CardDescription>
            <CardContent>
              <form
                onSubmit={handleSubmit}
                className='space-y-4'
              >
                <Input
                  type='text'
                  placeholder='Número de guía'
                  value={trackingNumber}
                  onChange={e => setTrackingNumber(e.target.value)}
                  required
                  className='w-full'
                />
                <input
                  type='submit'
                  value={isLoading ? 'Buscando...' : 'Rastrear envío'}
                  disabled={isLoading || trackingNumber.trim().length === 0}
                  className={`bg-primary-inabit-red mt-4 py-2 text-xl text-white rounded-xl w-full ${
                    isLoading || trackingNumber.trim().length === 0
                      ? 'opacity-50 cursor-not-allowed'
                      : 'hover:bg-primary-inabit-red-hover cursor-pointer'
                  }`}
                />
              </form>

              {error && (
                <Alert
                  variant='filled'
                  className='mt-4'
                  severity='error'
                >
                  <AlertTitle>Error</AlertTitle>
                  <p>{error}</p>
                </Alert>
              )}

              {packageStatus && (
                <div className='mt-6'>
                  <h3 className='text-xl font-semibold mb-2'>Resultado</h3>
                  <div className='flex items-center space-x-2'>
                    {packageStatus.status === 'en-camino' && (
                      <TruckIcon className='h-12 text-blue-500' />
                    )}
                    {packageStatus.status === 'entregado' && (
                      <CheckCircleIcon className='h-12 text-green-500' />
                    )}
                    {packageStatus.status === 'procesando' && (
                      <HourglassTopOutlinedIcon
                        className='h-12 text-yellow-500'
                        fontSize='large'
                      />
                    )}
                    {packageStatus.status === 'no-encontrado' && (
                      <XCircleIcon className='h-12 text-red-500' />
                    )}
                    {packageStatus.status === 'no-encontrado' && (
                      <XCircleIcon className='h-12 text-red-500' />
                    )}
                    {packageStatus.status === 'hay-un-problema' && (
                      <WarningIcon className='h-12 text-red-500' />
                    )}
                    <span className='capitalize font-bold text-2xl'>
                      {packageStatus.status.replaceAll('-', ' ')}
                    </span>
                  </div>
                  <p className='text-sm text-gray-600 mt-1'>
                    {packageStatus.message}
                  </p>
                  <p className='text-xs text-gray-500 mt-2'>
                    Última actualización: {packageStatus.updatedStatusAt}
                  </p>
                </div>
              )}
            </CardContent>
          </Card>
        </div>
      </CardContent>
      {/* Section 2 [Carousel]*/}
      <Carousel widthScreen={widthScreen} />

      {/* Section 3 [how does it service] */}
      <CardContent id='section3'>
        <CardContent id='textContainer'>
          <p id='howDoesItTextSection3'>¿CÓMO FUNCIONA?</p>
          <Header
            id='titleSection3'
            content='Estamos aquí para entregar tus envíos de la manera más económica y rápida.'
          />
          <p id='textSection3'>
            Consigue que tus clientes revisan el mejor servicio al menor costo y
            haz crecer tu negocio con nuestra plataforma de marketing avanzada.
          </p>
        </CardContent>
        <CardGroup id='divCardFunctions'>
          <Card
            id='cardFunctions1'
            image={FunctionIcon1}
            header='1. Regístrate'
            description='En menos de 5 minutos; confirma tu correo, documentación, haz una recarga y ¡estas listo para enviar! '
          />
          <Card
            id='cardFunctions2'
            image={FunctionIcon2}
            header='2. Cotiza'
            description='Revisa nuestros servicios disponibles y escoge el que mejor se adapte a tus necesidades.'
          />
          <Card
            id='cardFunctions3'
            image={FunctionIcon3}
            header='3. Envía'
            description='Genera tu guía, programa recolección o llévalo a tu sucursal más cercana y ¡listo!'
          />
        </CardGroup>
        <Button
          content='Empezar ahora'
          id='btnServices2'
          onClick={() => history.push(paths.SIGN_UP)}
        />
      </CardContent>

      {/* Section 4 [Brands and benefits] */}
      <Benefits widthScreen={widthScreen} />

      {/* Section 5 [Form]*/}
      <Form />

      {/* Section 6 [Map] */}
      <Branch widthScreen={widthScreen} />

      {/* Section 7 [Footer] */}
      <Footer widthScreen={widthScreen} />
    </CardContent>
  );
};

const withConnect = connect(
  selectState('tracking.trackingStatus', 'tracking.status'),
  actionProps({ ...trackingActions }),
);

export default compose(withConnect)(Tracking);
